<template>
  <div class="selectGoods">
    <!-- 新增商品弹框 -->
    <el-dialog :visible.sync="isVisiable" width="90%" @close="GoodsListDialogClosed" title="新增附属商品">
      <table-con :showBreadCrumb="false">
        <div slot="search">
          <el-row class="search-row">
            <el-col :span="5" class="lx-flex-row">
              <div class="title-seach">No:</div>
              <div class="flex1">
                <el-input clearable v-model="queryInfo.id" size="small" @keyup.enter.native="searchList"> </el-input>
              </div>
            </el-col>
            <el-col :span="5" class="lx-flex-row">
              <div class="title-seach">商品名:</div>
              <div class="flex1">
                <el-input clearable v-model="queryInfo.goodsName" size="small" @keyup.enter.native="searchList"> </el-input>
              </div>
            </el-col>
            <el-col :span="8" class="lx-flex-row">
              <div class="title-seach">FNSKU/YFFコード/STOCKCREWコード/JANコード:</div>
              <div class="flex1">
                <el-input clearable v-model="queryInfo.fnsku" size="small" @keyup.enter.native="searchList"> </el-input>
              </div>
            </el-col>
            <el-col :span="4" class="lx-flex-row">
              <div class="search-btn-container">
                <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
                <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <div slot="table">
          <el-table :data="GoodsList" border stripe style="width: 100%" @selection-change="handleSelectionChange"
            :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle">
            <el-table-column type="index" label="序号" align="center" width="40"></el-table-column>
            <el-table-column align="center" type="selection" :selectable='checkboxSelect' width="55"> </el-table-column>
            <el-table-column align="center" prop="id" label="No" width="70"> </el-table-column>
            <el-table-column prop="goodsName" label="商品名" min-width="200"></el-table-column>
            <el-table-column label="图片" min-width="250" align="center" width="250">
              <template slot-scope="scope">
                <img :src="scope.row.pictureUrl" @click="imgclick(scope.row.pictureUrl,true)" width="180" height="320"
                  class="head_pic" />
              </template>
            </el-table-column>
            <el-table-column prop="orderType" align="center" label="FBA/YFF/ZOZO/RSL/STOCKCREW" width="90">
              <template v-slot="scope">
                <div>{{ scope.row.orderType | isFBA }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="fnsku" label="编号" align="center"></el-table-column>
            <el-table-column prop="goodsNameCus" label="品名" align="center" width="250">
              <template v-slot="scope">
                <el-input type="textarea" placeholder="" v-model="scope.row.goodsNameCus" size="small" disabled>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="orderStatus" align="center" label="订单状态" width="90">
              <template v-slot="scope">
                <div v-for="(item, i) in orderStatusOptions" :key="i">
                  <div v-if="scope.row.orderStatus == item.value">
                    {{ item.label }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="categoryFlag" align="center" label="仓库保管" width="90">
              <template v-slot="scope">
                <div v-if="scope.row.categoryFlag == '0'">否</div>
                <div v-if="scope.row.categoryFlag == '1'">是</div>
              </template>
            </el-table-column>
            <el-table-column prop="goodsCount" label="商品数量" align="center"></el-table-column>
            <el-table-column prop="destroyCount" label="销毁数量" align="center" width="90"></el-table-column>
            <el-table-column prop="refundCount" label="退货数量" align="center" width="90"></el-table-column>
            <!-- <el-table-column prop="waitingCount" label="待装箱数" align="center" width="90"></el-table-column> -->
            <el-table-column prop="canApplyCount" label="可申请数" align="center" width="90"></el-table-column>
            <el-table-column prop="totalNetWeight" label="净重" align="center" width="90"></el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
            :page-sizes="[5, 10, 20, 50, 100]" :pager-count="5" :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          <!-- </div>  -->
          <div slot="footer" class="dialog-footer search-btn-container" style="padding: 12px 5px 0 20px">
            <el-button class="form-btn btn-gray" @click="CloseVisible">取消</el-button>
            <el-button class="form-btn btn-blue" @click="SubmitVisible">提交</el-button>
          </div>
        </div>
      </table-con>
    </el-dialog>

    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
  </div>
</template>
<script>
import tableCon from "../../../views/tableContainer";
const queryInfo = {
  userId: '',
  id: "",
  goodsName: "",
  fnsku: "",
  pageSize: 5,
  pageNum: 1,
}
export default {
  name: "AppendageSelectGoods",
  props: {
    isVisiable: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String,
      default: ''
    },
    selectedList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    tableCon
  },
  data () {
    return {
      queryInfo: this._.cloneDeep(queryInfo),
      total: 0,
      visible: false,
      GoodsList: [], //所有的商品列表
      TemporaryList: [], //临时的商品列表
      SelectedGoodsList: [], //选中的商品列表
      imgurl: '',
      //订单状态
      orderStatusOptions: [
        {
          value: "1",
          label: '待购买',
        },
        {
          value: "2",
          label: '购买完',
        },
        {
          value: "0",
          label: '等待到库',
        },
        {
          value: "4",
          label: '到库',
        },
        {
          value: "8",
          label: '检品中',
        },
        {
          value: "12",
          label: '检品完',
        }, {
          value: '16',
          label: '仓库保管中',
        }, {
          value: '20',
          label: '申请发货',
        }, {
          value: '24',
          label: '不良待处理',
        }, {
          value: '26',
          label: '不良驳回',
        }, {
          value: '28',
          label: '换货待发回',
        }, {
          value: '32',
          label: '换货等待到货',
        }, {
          value: '36',
          label: '待部分退货',
        }, {
          value: '40',
          label: '补发等待到货',
        }, {
          value: '44',
          label: '待支付',
        }, {
          value: '48',
          label: '待发送',
        }, {
          value: '52',
          label: '已发送',
        }, {
          value: '56',
          label: '已取消',
        }, {
          value: '60',
          label: '退货申请中',
        }, {
          value: '64',
          label: '退货待支付',
        }, {
          value: '68',
          label: '待退货',
        }, {
          value: '72',
          label: '已退货',
        }, {
          value: '76',
          label: '销毁申请中',
        }, {
          value: '80',
          label: '销毁待支付',
        }, {
          value: '82',
          label: '待部分销毁',
        }, {
          value: '83',
          label: '待销毁',
        }, {
          value: '84',
          label: '已销毁',
        }, {
          value: '88',
          label: '检品完',
        }, {
          value: '89',
          label: '无法购买',
        }
      ],
    };
  },
  watch: {
    isVisiable (val) {
      if (val) this.getGoodsList()
    }
  },
  methods: {
    //查询商品列表
    searchList () {
      this.queryInfo.pageNum = 1;
      this.getGoodsList();
    },
    // 重置
    queryInfoClear () {
      this.queryInfo = this._.cloneDeep(queryInfo)
    },
    //从后台获取商品列表
    async getGoodsList () {
      const params = { ...this.queryInfo, userId: this.userId }
      const { data: res } = await this.$http.post("order/appendageGoodsList", params);
      this.GoodsList = res.data.list;
      this.total = res.data.total;
    },
    //复选框选中插入临时表
    handleSelectionChange (val) {
      this.TemporaryList = val;
    },
    // 待装箱为0不可选中
    checkboxSelect (row, rowIndex) {
      if (row.canApplyCount == 0) {
        return false
      } else {
        return true
      }
    },
    imgclick (url, visible) {
      this.visible = true
      this.imgurl = url
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getGoodsList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getGoodsList();
    },
    GoodsListDialogClosed () {
      this.$emit('update:isVisiable', false)
      this.TemporaryList = [];
      this.SelectedGoodsList = [];
    },
    //提交搜索的商品
    SubmitVisible () {
      this.TemporaryList.forEach(p => {
        this.$set(p, 'containerGoodsCount', p.canApplyCount)
      })
      this.SelectedGoodsList.forEach((item) => {
        this.TemporaryList.forEach((o) => {
          if (o.id == item.id) {
            this.TemporaryList.splice(this.TemporaryList.indexOf(o), 1);
          }
        });
      });
      this.SelectedGoodsList = this.SelectedGoodsList.concat(
        this.TemporaryList
      );
      this.$emit('confirm', this.SelectedGoodsList)
      this.TemporaryList = [];
      this.SelectedGoodsList = [];
    },
    //关闭
    CloseVisible () {
      this.$emit('update:isVisiable', false)
      this.TemporaryList = [];
      this.SelectedGoodsList = [];
    },
  }
}
</script>
<style scoped>
.title-seach {
  padding: 6px 12px;
}
</style>
